/**
 * Kategori kartlarındaki görselleri sırayla döndürür.
 *
 * Tasarım kararları:
 *   - Görseller Liquid tarafında basılıdır; burada yalnızca `is-active` sınıfı
 *     taşınır. JS yüklenmezse ilk kare görünür kalır, kart bozulmaz.
 *   - `IntersectionObserver` ile yalnızca ekranda olan kartlar döner —
 *     görünmeyen kartlar zamanlayıcı çalıştırmaz.
 *   - Sekme arka plana alınınca (`visibilitychange`) tüm döngüler durur.
 *   - `prefers-reduced-motion` altında hiç başlamaz.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  const rotators = [];

  class Rotator {
    constructor(el) {
      this.el = el;
      this.frames = [...el.querySelectorAll('[data-frame]')];
      this.interval = Number(el.dataset.interval) || 5000;
      this.index = this.frames.findIndex((f) => f.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;
      this.timer = null;
      this.visible = false;
    }

    get canRotate() {
      return this.frames.length > 1;
    }

    start() {
      if (!this.canRotate || this.timer) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const current = this.frames[this.index];
      this.index = (this.index + 1) % this.frames.length;
      const upcoming = this.frames[this.index];
      current?.classList.remove('is-active');
      upcoming?.classList.add('is-active');
    }
  }

  const init = () => {
    document.querySelectorAll('[data-category-rotator]').forEach((el) => {
      if (el.dataset.rotatorReady) return;
      el.dataset.rotatorReady = 'true';
      rotators.push(new Rotator(el));
    });

    if (!rotators.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const rotator = rotators.find((r) => r.el === entry.target);
          if (!rotator) return;
          rotator.visible = entry.isIntersecting;
          if (entry.isIntersecting && !document.hidden) rotator.start();
          else rotator.stop();
        });
      },
      { rootMargin: '100px' }
    );

    rotators.forEach((r) => observer.observe(r.el));

    document.addEventListener('visibilitychange', () => {
      rotators.forEach((r) => {
        if (document.hidden) r.stop();
        else if (r.visible) r.start();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Tema düzenleyicide bölüm yeniden yüklendiğinde yeniden bağlan
  document.addEventListener('shopify:section:load', init);
})();
